import {
  Hospital, Stethoscope, FlaskConical, Pill, DollarSign, RefreshCw,
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle, TrendingUp,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { formatNum } from "@/lib/constants";
import { getEstadoPredominante } from "@/mocks/pipelineData";

const iconMap = {
  Hospital, Stethoscope, FlaskConical, Pill, DollarSign, RefreshCw,
  Search, Clock, MessageCircle, Phone, XCircle, Monitor, Bell, Calendar,
  BarChart3, UserCheck, Package, Link, CreditCard, FileText, AlertTriangle,
  CalendarCheck, MessageSquare, Database, Circle, TrendingUp,
};

export default function PipelineCard({ stage, selected, isCritico, onClick }) {
  const Icon = iconMap[stage.icono] || Circle;
  const estado = getEstadoPredominante(stage.sub_etapas);

  const estadoColor = {
    REAL: "bg-emerald-500",
    MOCK: "bg-slate-400",
    SIMULADO: "bg-amber-500",
    PENDIENTE: "bg-rose-500",
  };

  return (
    <button
      data-testid={`pipeline-card-${stage.id}`}
      onClick={() => onClick(stage.id)}
      className={cn(
        "relative flex flex-col items-center p-4 rounded-2xl border transition-all duration-300 cursor-pointer w-full",
        "hover:shadow-lg hover:-translate-y-0.5",
        selected && "ring-2 ring-offset-2 shadow-lg",
        isCritico && !selected && "border-rose-300 bg-rose-50/50",
        !isCritico && !selected && "border-slate-200 bg-white",
        selected && "bg-white"
      )}
      style={{
        borderColor: selected ? stage.color : undefined,
        ringColor: selected ? stage.color : undefined,
        "--tw-ring-color": selected ? stage.color : undefined,
      }}
    >
      {isCritico && (
        <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-full bg-rose-500 text-white text-[10px] font-bold whitespace-nowrap shadow-sm">
          Punto crítico
        </span>
      )}

      <div
        className="h-10 w-10 rounded-xl flex items-center justify-center text-white shadow-md"
        style={{ backgroundColor: stage.color }}
      >
        <Icon className="w-5 h-5" />
      </div>

      <span className="text-[10px] font-bold text-slate-400 mt-2 uppercase tracking-wider">
        Etapa {stage.id}
      </span>

      <span className="text-sm font-semibold text-slate-900 mt-1 text-center leading-tight">
        {stage.nombre}
      </span>

      <span className="text-2xl font-bold text-slate-900 mt-2 tabular-nums">
        {stage.volumen != null ? formatNum(stage.volumen) : "—"}
      </span>

      <span className="text-[11px] text-slate-500">pacientes</span>

      {stage.conversion_anterior != null && (
        <span className="text-xs font-medium text-emerald-600 mt-1">
          {stage.conversion_anterior.toFixed(1)}% conversión
        </span>
      )}

      {stage.delta_periodo != null && (
        <span className={cn(
          "text-[10px] font-semibold mt-0.5",
          stage.delta_periodo >= 0 ? "text-emerald-600" : "text-rose-600"
        )}>
          {stage.delta_periodo >= 0 ? "+" : ""}{stage.delta_periodo}pp
        </span>
      )}

      {/* Indicador de estado */}
      <span className={cn("absolute bottom-2 right-2 w-2 h-2 rounded-full", estadoColor[estado])} />
    </button>
  );
}
